export const MODAL_TYPE = {
  STORE: "store",
  UPDATE: "update",
}
